function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.166626,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#77A0C5",
    fillOpacity: 0.4,
    style: {
      fill: "#77A0C5",
      fill: "color(display-p3 0.4667 0.6275 0.7725)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1637 23.9909C14.0096 23.9604 12.0111 23.1001 10.5039 21.5932C8.99665 20.0862 8.16675 18.1186 8.16675 15.9955V15.8094C8.16675 15.6263 8.31931 15.4708 8.50543 15.4708L11.1507 15.5013C11.3338 15.5013 11.4894 15.6538 11.4894 15.8399V15.9619C11.4894 17.3773 11.7671 18.7287 12.2583 19.9306C13.1187 21.9287 14.5649 23.1916 16.1332 23.2526C16.3163 23.2526 16.4719 23.4052 16.4719 23.5913C16.4719 23.6828 16.4413 23.7773 16.3803 23.8383C16.3498 23.9604 16.2583 23.9909 16.1637 23.9909ZM10.4124 20.4248C11.1507 21.3796 12.1362 22.1484 13.2743 22.6395C12.6915 22.0538 12.1668 21.3156 11.7671 20.4248H10.4124ZM9.92113 19.7171L11.4589 19.7476C11.0592 18.6708 10.8426 17.4414 10.8121 16.212L8.84409 16.1815C8.90512 17.4719 9.2743 18.6738 9.92113 19.7171Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1812 16.209L8.50543 16.1785C8.41389 16.1785 8.31931 16.148 8.25829 16.0869C8.19726 16.0259 8.16675 15.9344 8.16675 15.8399C8.19726 13.7777 9.05768 11.8101 10.5649 10.3642C12.0722 8.88771 14.0401 8.05797 16.1637 8.02747C16.2552 8.02747 16.3468 8.05798 16.4108 8.11899C16.4719 8.18 16.5024 8.27151 16.5024 8.36608C16.5024 8.54911 16.3498 8.70468 16.1637 8.70468C14.5649 8.76569 13.1187 10.0591 12.2583 12.0877C11.7976 13.2256 11.5199 14.5159 11.5199 15.8704C11.5199 15.9619 11.4894 16.0534 11.4284 16.1175C11.3674 16.1785 11.2758 16.209 11.1812 16.209ZM8.87461 15.5043L10.8426 15.5348C10.8731 14.397 11.0897 13.3201 11.4589 12.3348L9.92113 12.3043C9.33532 13.2256 8.96919 14.3329 8.87461 15.5043ZM10.3819 11.5966L11.7365 11.6271C12.1667 10.7058 12.6915 9.93405 13.3048 9.3514C12.1362 9.81203 11.1202 10.6113 10.3819 11.5966Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1652 16.2394L11.1812 16.2089C10.9951 16.2089 10.8425 16.0564 10.8425 15.8703C10.873 14.4549 11.1507 13.0394 11.6419 11.8405C11.7029 11.7185 11.825 11.624 11.9806 11.624L14.5039 11.6545C14.5954 11.6545 14.6869 11.7155 14.7815 11.7765C14.8425 11.868 14.873 11.9595 14.8425 12.0541C14.6259 13.1919 14.5344 14.5464 14.5344 15.8977C14.5344 15.9893 14.5039 16.0808 14.4428 16.1448C14.3513 16.2058 14.2598 16.2363 14.1652 16.2363V16.2394ZM11.5504 15.5347L13.8265 15.5652C13.857 14.4274 13.918 13.3506 14.0736 12.3652L12.1667 12.3347C11.7975 13.2896 11.5809 14.3938 11.5504 15.5347Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4733 12.3348L11.9195 12.3043C11.7975 12.3043 11.7029 12.2433 11.6419 12.1518C11.5808 12.0602 11.5808 11.9352 11.6113 11.8132C12.5663 9.50696 14.2567 8.09152 16.1331 8C16.2246 8 16.3162 8.03051 16.3802 8.09152C16.4412 8.15253 16.4718 8.24405 16.4718 8.33861V8.36912C16.4718 8.52165 16.3802 8.67722 16.2246 8.70772C15.7944 8.82974 15.1781 9.90658 14.8089 12.0602C14.8089 12.2128 14.6563 12.3378 14.4702 12.3378L14.4733 12.3348ZM12.5053 11.6271L14.2292 11.6576C14.3818 10.8278 14.6594 9.7205 15.1201 8.95177C14.0431 9.38189 13.1522 10.3062 12.5053 11.6271Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 20.4858L11.9806 20.4553C11.8585 20.4553 11.7335 20.3638 11.6724 20.2387C11.1171 18.9788 10.8425 17.5024 10.8425 15.9954V15.8734C10.8425 15.7819 10.873 15.6873 10.9341 15.6263C10.9951 15.5653 11.0866 15.5348 11.1812 15.5348L14.1652 15.5653C14.3513 15.5653 14.5039 15.7178 14.5039 15.9039V15.9954C14.5039 17.4414 14.6259 18.8568 14.8425 20.0557C14.873 20.1472 14.8425 20.2723 14.7815 20.3333C14.7205 20.4248 14.6289 20.4858 14.5039 20.4858ZM12.2277 19.7476L14.1042 19.7781C13.918 18.7012 13.8265 17.5024 13.8265 16.2425L11.5199 16.212C11.5504 17.4719 11.7975 18.6738 12.2277 19.7476Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1636 23.9908C14.3177 23.8993 12.6274 22.5144 11.6724 20.2387C11.6114 20.1167 11.6419 19.9916 11.7029 19.9001C11.764 19.8086 11.886 19.7476 12.0111 19.7476L14.5344 19.7781C14.6869 19.7781 14.8425 19.9001 14.873 20.0557C15.2422 22.1148 15.8585 23.1611 16.2582 23.2557C16.4108 23.2862 16.5054 23.4387 16.5054 23.5943V23.6248C16.5054 23.7163 16.4749 23.8109 16.4138 23.8719C16.3528 23.9634 16.2613 23.9939 16.1667 23.9939L16.1636 23.9908ZM12.5359 20.4553C13.1827 21.7151 14.0736 22.6395 15.0897 23.0391C14.6594 22.3008 14.3818 21.2545 14.2292 20.4858L12.5359 20.4553Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1636 20.5162L14.5038 20.4857C14.3512 20.4857 14.1956 20.3637 14.1651 20.2082C13.9485 18.9483 13.8264 17.5023 13.8264 16.0259V15.9344C13.8264 15.8429 13.8569 15.7513 13.9179 15.6873C13.979 15.6263 14.0705 15.5958 14.1651 15.5958L16.1636 15.6263C16.3466 15.6263 16.5022 15.7788 16.5022 15.9649V20.1471C16.5022 20.2387 16.4717 20.3332 16.4107 20.3942C16.3497 20.4552 16.2581 20.5162 16.1636 20.5162ZM14.8119 19.778H15.8279V16.273L14.5373 16.2425C14.5373 17.5023 14.6289 18.7042 14.815 19.778H14.8119Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1636 16.273L14.1651 16.2425C13.982 16.2425 13.8264 16.09 13.8264 15.9039C13.8264 14.4885 13.9485 13.1371 14.1651 11.9352C14.1956 11.7827 14.3512 11.6576 14.5038 11.6576L16.1636 11.6881C16.3466 11.6881 16.5022 11.8406 16.5022 12.0267V15.9314C16.5022 16.0229 16.4717 16.1144 16.4107 16.1785C16.3497 16.2395 16.2581 16.27 16.1636 16.27V16.273ZM14.5343 15.5653L15.8249 15.5958V12.3653H14.7784C14.6258 13.3201 14.5312 14.4275 14.5312 15.5653H14.5343Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1638 12.3653L14.4734 12.3348C14.3819 12.3348 14.2873 12.2738 14.1958 12.2128C14.1348 12.1213 14.1043 12.0267 14.1348 11.9352C14.3514 10.6143 14.9342 8.33557 16.0722 8.03052C16.1638 8.00002 16.2889 8.03053 16.3804 8.09154C16.4719 8.15255 16.5024 8.24406 16.5024 8.36913V12.0298C16.5024 12.1213 16.4719 12.2158 16.4109 12.2769C16.3499 12.3379 16.2583 12.3684 16.1638 12.3684V12.3653ZM14.9037 11.6576H15.8251V9.0738C15.4864 9.53443 15.1477 10.3977 14.9037 11.6576Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1635 23.9603H16.072C14.9644 23.6522 14.4122 21.4681 14.165 20.2082C14.1345 20.1167 14.165 19.9916 14.2261 19.9306C14.2871 19.8391 14.3786 19.8086 14.5037 19.8086L16.1635 19.8391C16.3466 19.8391 16.5022 19.9916 16.5022 20.1777V23.6217C16.5022 23.7438 16.4412 23.8383 16.3801 23.8993C16.3191 23.9298 16.2276 23.9603 16.1635 23.9603ZM14.9339 20.4858C15.1811 21.6847 15.5197 22.4534 15.8248 22.914V20.5163L14.9339 20.4858Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1636 16.273L14.1651 16.2425C13.982 16.2425 13.8264 16.09 13.8264 15.9039C13.8264 15.7178 13.979 15.5653 14.1651 15.5653L16.1636 15.5958C16.3466 15.5958 16.5022 15.7483 16.5022 15.9344C16.5022 16.1205 16.3497 16.273 16.1636 16.273Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1652 16.2394L11.1812 16.2089C10.9951 16.2089 10.8425 16.0564 10.8425 15.8703C10.8425 15.6842 10.9951 15.5317 11.1812 15.5317L14.1652 15.5622C14.3513 15.5622 14.5039 15.7147 14.5039 15.9008C14.5039 16.0869 14.3513 16.2394 14.1652 16.2394Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1812 16.209L8.50543 16.1785C8.31931 16.1785 8.16675 16.026 8.16675 15.8399C8.16675 15.6538 8.31931 15.5013 8.50543 15.5013L11.1507 15.5318C11.3338 15.5318 11.4894 15.6843 11.4894 15.8704C11.5199 16.0534 11.3674 16.209 11.1812 16.209Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53594 16.1785C8.35288 16.1785 8.19727 16.026 8.19727 15.8399C8.19727 15.6538 8.34983 15.5013 8.53594 15.5013C8.72206 15.5013 8.87461 15.6538 8.87461 15.8399C8.87461 16.026 8.72206 16.1785 8.53594 16.1785Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4733 12.3349L11.9195 12.3044C11.7334 12.3044 11.5808 12.1518 11.5808 11.9657C11.5808 11.7797 11.7334 11.6271 11.9195 11.6271L14.4427 11.6576C14.6289 11.6576 14.7814 11.8102 14.7814 11.9962C14.8424 12.1793 14.6899 12.3349 14.4733 12.3349Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1635 12.3653L14.4732 12.3348C14.2871 12.3348 14.1345 12.1823 14.1345 11.9962C14.1345 11.8101 14.2871 11.6576 14.4732 11.6576L16.133 11.6881C16.3161 11.6881 16.4717 11.8406 16.4717 12.0267C16.5022 12.2128 16.3496 12.3653 16.1635 12.3653Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.95 12.3043L9.85698 12.2738C9.67391 12.2738 9.51831 12.1213 9.51831 11.9352C9.51831 11.7491 9.67086 11.5966 9.85698 11.5966L11.95 11.6271C12.1331 11.6271 12.2887 11.7796 12.2887 11.9657C12.2887 12.1517 12.1362 12.3043 11.95 12.3043Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1638 20.5163L14.504 20.4858C14.3209 20.4858 14.1653 20.3333 14.1653 20.1472C14.1653 19.9611 14.3178 19.8086 14.504 19.8086L16.1638 19.8391C16.3468 19.8391 16.5024 19.9916 16.5024 20.1777C16.5024 20.3638 16.3499 20.5163 16.1638 20.5163Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5038 20.4858L11.9805 20.4553C11.7974 20.4553 11.6418 20.3028 11.6418 20.1167C11.6418 19.9306 11.7944 19.7781 11.9805 19.7781L14.5038 19.8086C14.6868 19.8086 14.8425 19.9611 14.8425 20.1472C14.873 20.3333 14.6899 20.4858 14.5038 20.4858Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9805 20.4248L9.85698 20.3943C9.67391 20.3943 9.51831 20.2417 9.51831 20.0557C9.51831 19.8696 9.67086 19.717 9.85698 19.717L11.9805 19.7475C12.1667 19.7475 12.3192 19.9001 12.3192 20.0862C12.3192 20.3027 12.1667 20.4248 11.9805 20.4248Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6578 23.9908H16.1665C15.9835 23.9908 15.8279 23.8383 15.8279 23.6522V19.409C15.8279 19.2259 15.9804 19.0704 16.1665 19.0704C17.8569 18.9788 19.1505 17.6549 19.1505 15.9954C19.1505 14.336 17.8263 13.012 16.1665 12.9205C15.9835 12.9205 15.8279 12.768 15.8279 12.5819V8.36913C15.8279 8.18305 15.9804 8.03052 16.1665 8.03052H16.7188C16.9049 8.03052 17.027 8.15254 17.0575 8.33862L17.3046 10.0927C18.043 10.2452 18.7508 10.5228 19.3977 10.9529L20.8134 9.90659C20.9354 9.81507 21.1521 9.81507 21.2741 9.93709L22.2596 10.8919C22.3816 11.0139 22.4122 11.2 22.2901 11.3525L21.2436 12.707C21.6433 13.3232 21.9514 14.0309 22.104 14.7661L23.8584 15.0132C24.0445 15.0437 24.1665 15.1962 24.1665 15.3518V16.7062C24.1665 16.8892 24.0445 17.0143 23.8584 17.0448L22.104 17.2919C21.9514 18.0301 21.6433 18.7073 21.2131 19.3541L22.2596 20.739C22.3511 20.8915 22.3511 21.0776 22.2291 21.1996L21.2436 22.1544C21.1215 22.2765 20.9354 22.2765 20.7829 22.1849L19.3367 21.1386C18.6898 21.5382 17.982 21.8158 17.2436 21.9684L16.9964 23.6919C16.9659 23.8749 16.8439 24 16.6578 24V23.9908ZM16.5022 19.7171V22.2399L16.5937 21.5931C16.6242 21.4406 16.7463 21.3155 16.8714 21.285C17.7013 21.163 18.4701 20.8549 19.1475 20.3943C19.2695 20.3028 19.4251 20.3028 19.5472 20.3943L20.9324 21.4101L21.4877 20.858L20.4717 19.5035C20.3801 19.3815 20.3801 19.1954 20.4717 19.0734C20.9629 18.4267 21.3016 17.658 21.4236 16.8587C21.4541 16.7062 21.5762 16.5811 21.7318 16.5811L23.4221 16.334V15.5653L21.7318 15.3182C21.5792 15.2877 21.4541 15.1962 21.4236 15.0406C21.3016 14.2414 20.9629 13.4726 20.5022 12.7954C20.4106 12.6734 20.4106 12.4873 20.5022 12.3958L21.5487 11.0414L20.9965 10.4892L19.6112 11.5051C19.4892 11.5966 19.3336 11.5966 19.2116 11.5051C18.5342 11.0444 17.7653 10.7058 16.9354 10.5838C16.7829 10.5533 16.6578 10.4313 16.6578 10.3062L16.5052 9.16837V12.1823C18.3817 12.4294 19.8279 13.9973 19.8279 15.9039C19.8279 17.8105 18.4122 19.473 16.5052 19.7171H16.5022Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1636 19.7475C16.0721 19.7475 15.9806 19.717 15.9165 19.656C15.8555 19.595 15.825 19.5035 15.825 19.4089V17.4413C15.825 17.2552 15.947 17.1027 16.1331 17.1027C16.7159 17.0417 17.1491 16.5506 17.1491 15.9954C17.1491 15.4402 16.7189 14.949 16.1331 14.888C15.947 14.8575 15.825 14.7355 15.825 14.5494V12.5818C15.825 12.4903 15.8555 12.3958 15.9165 12.3347C15.9775 12.2737 16.069 12.2432 16.1636 12.2432C18.2231 12.3347 19.825 13.9973 19.825 15.9954C19.825 17.9935 18.2262 19.656 16.1636 19.7475ZM16.5023 17.7494V19.0398C18.0095 18.7927 19.1171 17.5328 19.1171 15.9954C19.1171 14.4579 17.979 13.198 16.5023 12.9509V14.2413C17.2712 14.4579 17.8234 15.1626 17.8234 15.9954C17.8234 16.8282 17.3017 17.5023 16.5023 17.7494Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1636 17.8104C16.0721 17.8104 16.0111 17.7799 15.9165 17.7189C15.8555 17.6579 15.7944 17.5664 15.7944 17.4718V14.5494C15.7944 14.4579 15.825 14.3633 15.9165 14.3023C15.9775 14.2413 16.1026 14.2108 16.1941 14.2108C17.1186 14.3023 17.8234 15.0711 17.8234 16.0259C17.8234 16.9807 17.1156 17.7159 16.1941 17.8409C16.1941 17.8104 16.1636 17.8104 16.1636 17.8104ZM16.5023 14.9795V16.9776C16.8715 16.7946 17.1491 16.4255 17.1491 15.9618C17.1491 15.4981 16.902 15.1626 16.5023 14.9765V14.9795Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.f0d44709b94dc18c7f7a149c6ae03a5f.svg";
export { ForwardRef as ReactComponent };